import React from 'react';

const SVG = ({
  style = {},
  fill = '#666',
  viewBox = '0 0 12 12',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" id="prefix__not-available" width={width} height={height} viewBox={viewBox}>
      <path d="M322.7 384.348a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6zm5 6a4.954 4.954 0 0 1-1 2.969l-7.329-6.672a4.978 4.978 0 0 1 8.329 3.7zm-10 0a4.951 4.951 0 0 1 1-2.964l7.328 6.671a4.977 4.977 0 0 1-8.324-3.707z" fill={fill} data-name="Path 2225" transform="translate(-316.697 -384.348)" />
      <path d="M322.7 384.348a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6zm5 6a4.954 4.954 0 0 1-1 2.969l-7.329-6.672a4.978 4.978 0 0 1 8.329 3.7zm-10 0a4.951 4.951 0 0 1 1-2.964l7.328 6.671a4.977 4.977 0 0 1-8.324-3.707z" fill={fill} data-name="Path 2226" transform="translate(-316.697 -384.348)" />
    </svg>
  );

export default SVG;